/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsonetoonemeetups4Inputs */

const en_statsonetoonemeetups4 = /** @type {(inputs: Statsonetoonemeetups4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1 meetups`)
};

const de_statsonetoonemeetups4 = /** @type {(inputs: Statsonetoonemeetups4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1-Treffen`)
};

/**
* | output |
* | --- |
* | "1:1 meetups" |
*
* @param {Statsonetoonemeetups4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsonetoonemeetups4 = /** @type {((inputs?: Statsonetoonemeetups4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsonetoonemeetups4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsonetoonemeetups4(inputs)
	return de_statsonetoonemeetups4(inputs)
});
export { statsonetoonemeetups4 as "statsOneToOneMeetups" }